import { Pipe, PipeTransform } from "@angular/core";
import { LANGUAGES_WITH_PREFIXED_DENOMINATION } from "@helpers/constants";
import { TranslationService } from "@core-services/translation.service";

// Pipe must be called again after language change
@Pipe({
	name: "new_fiat_symbol",
	standalone: false
})
// TODO FiatSymbolPipe -> SymbolPipe ?
export class FiatSymbolPipe implements PipeTransform {
	constructor(private readonly translationService: TranslationService) {}

	public transform(amount: string | number, symbol: string): string {
		const lang = this.translationService.getLanguage();
		if (LANGUAGES_WITH_PREFIXED_DENOMINATION.includes(lang)) {
			return `${amount} ${symbol}`;
		}
		return `${symbol} ${amount}`;
	}
}
